import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const imagesAnimate = document.querySelectorAll('.image-animate')

imagesAnimate.forEach((image) => {
	gsap.set(image, {
		filter: 'grayscale(100%)',
	})

	gsap.to(image, {
		duration: 3,
		'-webkit-filter': 'grayscale(0%)',
		filter: 'grayscale(0%)',
		ease: 'power4.out',
		scrollTrigger: {
			trigger: image,
			start: 'top bottom',
		},
	})
})
